import { useEffect, useState } from "react";
import messages from "@/lib/dailyMessages.json";

export function parisDayIndex(date = new Date()) {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Paris", year: "numeric", month: "numeric", day: "numeric" }).formatToParts(date);
  const value = type => Number(parts.find(p => p.type === type).value);
  // Continuous 365-day cycle: leap days also receive a new message.
  return ((Math.floor(Date.UTC(value("year"), value("month") - 1, value("day")) / 86400000) % 365) + 365) % 365;
}
export default function DailyMessage() {
  const [day, setDay] = useState(() => parisDayIndex());
  useEffect(() => {
    const update = () => setDay(parisDayIndex());
    const timer = setInterval(update, 30000);
    document.addEventListener("visibilitychange", update);
    return () => { clearInterval(timer); document.removeEventListener("visibilitychange", update); };
  }, []);
  return <aside data-testid="daily-message" aria-label="Message positif du jour" className="dl-daily-message">
    <span className="dl-daily-label">Une pensée pour aujourd’hui</span>
    <p>{messages[day]}</p>
  </aside>;
}
